// A prediction's PnL in percent: the backend's `performance` (a signed
// ratio, already in the predicted direction) × leverage × 100. Every PnL
// surface reads this one formula — never re-derived inline.
export function pnlPct(prediction: {
  performance: number;
  leverage: number;
}): number {
  return prediction.performance * prediction.leverage * 100;
}
